import React from "react";

export function RightArrowIcon() {
    return <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.397802 13.4826C-0.164103 14.0913 -0.126144 15.0403 0.482587 15.6022C1.09132 16.1641 2.04031 16.1261 2.60221 15.5174L8.60221 9.01742C9.1326 8.44283 9.1326 7.55717 8.60221 6.98258L2.60221 0.482587C2.04031 -0.126144 1.09132 -0.164103 0.482587 0.397802C-0.126144 0.959707 -0.164103 1.90869 0.397802 2.51743L5.45864 8L0.397802 13.4826Z" fill="none"/>
    </svg>;
}
